import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import EventImage from '../../Assets/images/Banner/Poster.jpg'; // Replace with your event image path

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogTitle-root': {
    paddingRight: theme.spacing(5),
    paddingBottom: 0
  }
}));

export default function EventRegistrationPopup({
  open = false,
  handleClose = () => {}
}) {
  const handleRegisterClick = () => {
    window.open(
      'https://www.theticket9.com/event/beat-the-sweet-marathon',
      '_blank'
    );
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle
        className="flash-text"
        sx={{ fontWeight: 'bold', fontSize: '22px', textAlign: 'center' }}
      >
        {`Feel the Rush  - Join the Run!`}
        <p
          style={{ padding: '0px', margin: '0px' }}
        >{`Early Bird Registration Now live . Don't Miss Out !`}</p>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500]
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <img
          src={EventImage} // Replace with your event image
          alt="Event"
          style={{
            width: '100%',
            borderRadius: '12px',
            marginBottom: '16px',
            objectFit: 'cover'
          }}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            borderRadius: '8px',
            fontWeight: 'bold',
            fontSize: '16px'
          }}
          onClick={handleRegisterClick}
        >
          Register Now
        </Button>
      </DialogContent>
    </StyledDialog>
  );
}
